module.exports = __webpack_public_path__ + "img/111m.d281a484.gif";